import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import esApp from './locales/es/app.json';
import esBankTransfers from './locales/es/bankTransfers.json';
import esBrand from './locales/es/brand.json';
import esBrandTabs from './locales/es/brandTabs.json';
import esConversations from './locales/es/conversations.json';
import esCoupons from './locales/es/coupons.json';
import esDiscounts from './locales/es/discounts.json';
import esLocations from './locales/es/locations.json';
import esMenu from './locales/es/menu.json';
import esOrders from './locales/es/orders.json';
import esPlayground from './locales/es/playground.json';
import esPos from './locales/es/pos.json';
import esResults from './locales/es/results.json';
import esTemplates from './locales/es/templates.json';

import enApp from './locales/en/app.json';
import enBankTransfers from './locales/en/bankTransfers.json';
import enBrand from './locales/en/brand.json';
import enBrandTabs from './locales/en/brandTabs.json';
import enConversations from './locales/en/conversations.json';
import enCoupons from './locales/en/coupons.json';
import enDiscounts from './locales/en/discounts.json';
import enLocations from './locales/en/locations.json';
import enMenu from './locales/en/menu.json';
import enOrders from './locales/en/orders.json';
import enPlayground from './locales/en/playground.json';
import enPos from './locales/en/pos.json';
import enResults from './locales/en/results.json';
import enTemplates from './locales/en/templates.json';

const resources = {
  es: {
    app: esApp,
    bankTransfers: esBankTransfers,
    brand: esBrand,
    brandTabs: esBrandTabs,
    conversations: esConversations,
    coupons: esCoupons,
    discounts: esDiscounts,
    locations: esLocations,
    menu: esMenu,
    orders: esOrders,
    playground: esPlayground,
    pos: esPos,
    results: esResults,
    templates: esTemplates,
  },
  en: {
    app: enApp,
    bankTransfers: enBankTransfers,
    brand: enBrand,
    brandTabs: enBrandTabs,
    conversations: enConversations,
    coupons: enCoupons,
    discounts: enDiscounts,
    locations: enLocations,
    menu: enMenu,
    orders: enOrders,
    playground: enPlayground,
    pos: enPos,
    results: enResults,
    templates: enTemplates,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    defaultNS: 'app',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

/**
 * Keep `<html lang>` in sync with the language i18next actually resolved.
 *
 * A lang attribute that disagrees with the copy on screen is what makes Chrome offer — and, for
 * anyone who has ever accepted "always translate", silently apply — a page translation. Google
 * Translate rewrites our text nodes, which crashes React on the next unmount with
 * "Failed to execute 'removeChild' on 'Node'". index.html sets the initial value before first
 * paint and opts the page out of translation entirely; this keeps the attribute honest after
 * detection settles and whenever the header's language switcher fires.
 */
const syncHtmlLang = () => {
  document.documentElement.lang = i18n.resolvedLanguage ?? i18n.language ?? 'es';
};

syncHtmlLang();
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
